import React from "react";
import PurchaseListSkeleton from "../PurchaseListSkeleton";

const PurchasedSkeleton: React.FC = () => {
  return (
    <div className="relative ps-14 pe-9 pb-20 pt-10 max-lg:px-9 max-md:p-0">
      <div className="relative">
        <h2 className="w-full text-2xl mb-6 flex items-center gap-1">
          PURCHASED EPISODES, MUSIC & EMOJIS{" "}
          <div className="skeleton w-6 min-h-6 !rounded-md"></div>
        </h2>
        <div className="w-full max-md:max-h-full">
          <div className="flex items-center justify-start gap-6 overflow-auto max-md:gap-4 w-full pb-2 mb-2">
            <button className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
              All
              <div className="skeleton w-6 min-h-6 !rounded-md"></div>
            </button>
            <button className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
              Episodes
              <div className="skeleton w-6 min-h-6 !rounded-md"></div>
            </button>
            <button className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
              Music
              <div className="skeleton w-6 min-h-6 !rounded-md"></div>
            </button>
            <button className="text-[#89D9EE] text-2xl max-md:text-xl flex-shrink-0 hover:opacity-100 flex items-center gap-1">
              Emojis
              <div className="skeleton w-6 min-h-6 !rounded-md"></div>
            </button>
          </div>
          <div className="grid grid-cols-1 gap-3 items-center justify-start max-h-[80vh] max-md:max-h-none overflow-auto md:pe-3 purchase-list-section">
            {[1, 2, 3, 4].map((item) => {
              return (
                <React.Fragment key={item}>
                  <PurchaseListSkeleton />
                  <div className="bg-no-repeat bg-contain bg-center bg-[url('@assets/images/ContactBorder.png')] w-full h-6 last:hidden max-md:hidden"></div>
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchasedSkeleton;
